import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Typography
} from '@one-thd/sui-atomic-components';
import ErrorBoundary from '../contexts/ErrorBoundary';
import { BannerContext, BannerProvider } from '../contexts/BannerContext';
import { updateLanguagePreference } from '../apis/language';
import MarketingPreferencesCard from './common/MarketingPreferencesCard';
import { initialLanguagePreferenceTableData } from './tableData';
import { setupHandleLangRetrieve } from '../apis/common';
import { retrieveEmailPreferences } from '../apis/email';
import { addAnalyticEvent } from '../analytics/common';
import {
  languageUpdateError
} from '../analytics/language';

export const saveChangeButton = 'language-save-change';

export function Preferences({ email }) {
  const {
    openErrorAlert, openSuccessAlert, closeSuccessAlert,
  } = React.useContext(BannerContext);

  const [tableData, setTableData] = React.useState(initialLanguagePreferenceTableData());
  const [initialSubs, setInitialSubs] = React.useState('');
  const [selected, setSelected] = React.useState('');
  const handleRetrieve = setupHandleLangRetrieve(tableData, setTableData, setSelected, setInitialSubs);

  function handleSuccess(res) {
    openSuccessAlert();
    handleRetrieve(res);
  }

  function handleError() {
    openErrorAlert();
  }

  React.useEffect(() => {
    retrieveEmailPreferences(email, handleRetrieve, handleError);
  }, []);

  const clickSaveChanges = () => {
    if ((selected !== initialSubs) && (selected.length > 0)) {
      closeSuccessAlert();
      updateLanguagePreference(email, selected, tableData,
        (res) => {
          // TODO determine if analytic event is needed
          handleSuccess(res);
        }, (err) => {
          addAnalyticEvent(languageUpdateError);
          handleError(err);
        });
    }
  };

  return (
    <div className="sui-grid sui-gap-4">
      <Typography variant="h2" weight="display">PERSONALIZATION</Typography>
      <Typography variant="body-base" height="none">
        To make changes to your preferences, click on the individual preference options below.
      </Typography>
      <MarketingPreferencesCard
        tableData={tableData}
        setTableData={setTableData}
        setSelected={setSelected}
        isProXtra
        isLangPref
        preferences={initialSubs}
      />
      <div className="sui-grid sui-grid-cols-8">
        <div className="hidden sm:sui-col-span-4 md:sui-col-span-5" />
        <div className="sui-col-span-8 sm:sui-col-span-4 md:sui-col-span-3 sui-grid sui-gap-y-4">
          <Button aria-label={saveChangeButton} fullWidth onClick={clickSaveChanges}>
            Save Changes
          </Button>
        </div>
      </div>
    </div>
  );
}

function LanguagePreference({ email }) {

  return (
    <ErrorBoundary>
      <BannerProvider>
        <Preferences email={email} />
      </BannerProvider>
    </ErrorBoundary>
  );
}

export default LanguagePreference;

const proptypes = {
  email: PropTypes.string.isRequired
};

LanguagePreference.propTypes = proptypes;
Preferences.propTypes = proptypes;
